var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 18.6737C20.0002 19.4058 19.406 20 18.6739 20C17.9418 20 17.3477 19.4058 17.3477 18.6737C17.3477 17.9416 17.9418 17.3475 18.6739 17.3475C19.406 17.3475 20.0002 17.9416 20.0002 18.6737Z",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72137 18.6737C4.72137 19.4058 4.1272 20 3.39511 20C2.66301 20 2.06885 19.4058 2.06885 18.6737C2.06885 17.9416 2.66301 17.3475 3.39511 17.3475C4.1272 17.3475 4.72137 17.9416 4.72137 18.6737Z",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38992 1.69761L2.80106 0H0V0.901857H2.2122L5.2626 12.2175C3.54377 12.817 2.08488 14.2281 1.79841 16.0955C1.69761 16.7162 1.69761 16.9761 1.69761 16.9761H20.3714V16.0902H2.72149C2.97082 14.4138 4.77984 13.008 6.65252 12.7745C8.5252 12.5411 19.5597 10.9602 19.5597 10.9602L20.3714 1.69761H3.38992ZM18.6737 10.1857L6.2069 11.9523C6.15915 11.9629 6.11141 11.9735 6.06366 11.9841L3.69231 2.57825H19.4854L18.6737 10.1857Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2356ea0bd13bff94637c2b9376eda6f0.svg";
export { ForwardRef as ReactComponent };